// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background: #f5f5f5;
}

.about-page {
  margin-top: 2rem;
  margin-bottom: 3rem;
}
.bread-crumb-static {
  padding-left: 4.46rem;
}

.section-padding {
  padding: 2rem 0;
}

.container {
  max-width: 1140px;
  margin: 0 auto;
  padding: 0 15px;
}

.about-title-row {
  text-align: center;
}

.about-title {
  font-family: "Roboto", sans-serif;
  font-weight: 900;
  word-wrap: break-word;
}

.about-title-black {
  color: black;
  font-size: 23px;
}

.about-title-highlight {
  color: #d2042d;
  font-size: 23px;
}

.about-us-text {
  color: #3b3f3d;
  font-size: 14px;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  word-wrap: break-word;
  margin-top: 0.8em;
}

.responsive-image {
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
  border-radius: 10px;
}

.about-content-section {
  padding: 0 1.5rem;
}
.content-row-1 {
  padding: 2rem 0rem 0rem 0rem;
}

.vision-header {
  margin: 0;
  font-size: 23px;
  font-family: "Roboto", sans-serif;
  font-weight: 900;
  word-wrap: break-word;
}

.vision-text-black {
  color: black;
}

.vision-text-highlight {
  color: #d2042d;
}

.paragraph-column {
  justify-content: center;
  align-items: center;
}

.highlighted-text {
  color: #0a0f0d;
  font-size: 14px;
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  line-height: 24px;
  word-wrap: break-word;
  margin-bottom: 5px;
}

.paragraph-text {
  color: #3b3f3d;
  font-size: 14px;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  line-height: 24px;
  word-wrap: break-word;
  margin: 0;
  text-align: justify;
  margin-bottom: 30px;
}

/* Styling for the responsive box */
.responsive-box {
  width: 100%;
  height: 100%;
  border: 1px solid #7c7c7c;
  margin-top: 40px;
}

/* Register Now Button */
.register-now-btn {
  width: 100%;
  max-width: 200px;
  height: auto;
  padding: 12px 20px;
  background: #d2042d;
  border-radius: 5px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: white;
  font-size: 19px;
  font-family: "Roboto", sans-serif;
  font-weight: 600;
  line-height: 25.6px;
  white-space: nowrap;
}

.register-now-btn:hover {
  background: #b00226 !important;
  color: white !important;
}

@media (max-width: 768px) {
  .about-title-black,
  .about-title-highlight {
    font-size: 23px;
  }
  .bread-crumb-static {
    display: none;
  }

  .about-us-text {
    font-size: 14px;
  }

  .vision-header {
    font-size: 23px;
  }

  .paragraph-text {
    font-size: 14px;
    line-height: 22px;
  }

  .responsive-box {
    height: 50%;
  }

  .highlighted-text {
    font-size: 16px;
    line-height: 22px;
  }

  .register-now-btn {
    font-size: 16px;
    line-height: 22px;
    padding: 10px 16px;
  }
}

@media (max-width: 576px) {
  .section-padding {
    padding: 1rem 0;
  }

  .about-title-black,
  .about-title-highlight {
    font-size: 19px;
  }

  .about-us-text {
    font-size: 12px;
  }

  .vision-header {
    font-size: 19px;
    text-align: center;
  }
   .highlighted-text {
    font-size: 14px;
    line-height: 22px;
  }

  .responsive-image {
    margin-bottom: 1.5rem;
  }
    .paragraph-text {
    font-size: 12px;
    line-height: 22px;
  }
 .register-now-btn {
    font-size: 14px;
    line-height: 22px;
    padding: 10px 16px;
  }

  .about-content-section {
    padding: 0;
  }

  .responsive-box {
    display: none;
  }

  .register-button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 16px;
  }

  .mobile-RegisBtnContainer p {
    text-align: center;
    margin-bottom: 5px;
  }

  .mobile-RegisBtnContainer {
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    padding: 20px;
  }
}

@media (min-width: 1024px) {
  .about-title-black,
  .about-title-highlight {
    font-size: 23px;
  }

  .about-us-text {
    font-size: 14px;
  }
}

@media (max-width: 1024px) {
  .about-page {
    margin-top: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/about/AboutPage.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE;;IAEE,eAAe;EACjB;EACA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;GACC;IACC,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;IACE;IACA,eAAe;IACf,iBAAiB;EACnB;CACD;IACG,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["body {\n  background: #f5f5f5;\n}\n\n.about-page {\n  margin-top: 2rem;\n  margin-bottom: 3rem;\n}\n.bread-crumb-static {\n  padding-left: 4.46rem;\n}\n\n.section-padding {\n  padding: 2rem 0;\n}\n\n.container {\n  max-width: 1140px;\n  margin: 0 auto;\n  padding: 0 15px;\n}\n\n.about-title-row {\n  text-align: center;\n}\n\n.about-title {\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 900;\n  word-wrap: break-word;\n}\n\n.about-title-black {\n  color: black;\n  font-size: 23px;\n}\n\n.about-title-highlight {\n  color: #d2042d;\n  font-size: 23px;\n}\n\n.about-us-text {\n  color: #3b3f3d;\n  font-size: 14px;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 400;\n  word-wrap: break-word;\n  margin-top: 0.8em;\n}\n\n.responsive-image {\n  width: 100%;\n  height: auto;\n  display: block;\n  margin: 0 auto;\n  border-radius: 10px;\n}\n\n.about-content-section {\n  padding: 0 1.5rem;\n}\n.content-row-1 {\n  padding: 2rem 0rem 0rem 0rem;\n}\n\n.vision-header {\n  margin: 0;\n  font-size: 23px;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 900;\n  word-wrap: break-word;\n}\n\n.vision-text-black {\n  color: black;\n}\n\n.vision-text-highlight {\n  color: #d2042d;\n}\n\n.paragraph-column {\n  justify-content: center;\n  align-items: center;\n}\n\n.highlighted-text {\n  color: #0a0f0d;\n  font-size: 14px;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 700;\n  line-height: 24px;\n  word-wrap: break-word;\n  margin-bottom: 5px;\n}\n\n.paragraph-text {\n  color: #3b3f3d;\n  font-size: 14px;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 400;\n  line-height: 24px;\n  word-wrap: break-word;\n  margin: 0;\n  text-align: justify;\n  margin-bottom: 30px;\n}\n\n/* Styling for the responsive box */\n.responsive-box {\n  width: 100%;\n  height: 100%;\n  border: 1px solid #7c7c7c;\n  margin-top: 40px;\n}\n\n/* Register Now Button */\n.register-now-btn {\n  width: 100%;\n  max-width: 200px;\n  height: auto;\n  padding: 12px 20px;\n  background: #d2042d;\n  border-radius: 5px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  color: white;\n  font-size: 19px;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 600;\n  line-height: 25.6px;\n  white-space: nowrap;\n}\n\n.register-now-btn:hover {\n  background: #b00226 !important;\n  color: white !important;\n}\n\n@media (max-width: 768px) {\n  .about-title-black,\n  .about-title-highlight {\n    font-size: 23px;\n  }\n  .bread-crumb-static {\n    display: none;\n  }\n\n  .about-us-text {\n    font-size: 14px;\n  }\n\n  .vision-header {\n    font-size: 23px;\n  }\n\n  .paragraph-text {\n    font-size: 14px;\n    line-height: 22px;\n  }\n\n  .responsive-box {\n    height: 50%;\n  }\n\n  .highlighted-text {\n    font-size: 16px;\n    line-height: 22px;\n  }\n\n  .register-now-btn {\n    font-size: 16px;\n    line-height: 22px;\n    padding: 10px 16px;\n  }\n}\n\n@media (max-width: 576px) {\n  .section-padding {\n    padding: 1rem 0;\n  }\n\n  .about-title-black,\n  .about-title-highlight {\n    font-size: 19px;\n  }\n\n  .about-us-text {\n    font-size: 12px;\n  }\n\n  .vision-header {\n    font-size: 19px;\n    text-align: center;\n  }\n   .highlighted-text {\n    font-size: 14px;\n    line-height: 22px;\n  }\n\n  .responsive-image {\n    margin-bottom: 1.5rem;\n  }\n    .paragraph-text {\n    font-size: 12px;\n    line-height: 22px;\n  }\n .register-now-btn {\n    font-size: 14px;\n    line-height: 22px;\n    padding: 10px 16px;\n  }\n\n  .about-content-section {\n    padding: 0;\n  }\n\n  .responsive-box {\n    display: none;\n  }\n\n  .register-button-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 16px;\n  }\n\n  .mobile-RegisBtnContainer p {\n    text-align: center;\n    margin-bottom: 5px;\n  }\n\n  .mobile-RegisBtnContainer {\n    background-color: #fff;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n    padding: 20px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .about-title-black,\n  .about-title-highlight {\n    font-size: 23px;\n  }\n\n  .about-us-text {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .about-page {\n    margin-top: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
